export { default } from "./AdMarqueeCarousel";
